import { commonRowAndCellClassRules } from '_legacy/components/grid/classRules/classRules';
import allowUpAndDownOnEdit from '_legacy/components/grid/columnDefaults/allowUpAndDownOnEdit';
import defaultSetFilterParams from '_legacy/components/grid/columnDefaults/defaultSetFilterParams';
import naturalSortComparator from '_legacy/components/grid/comparators/NaturalSortComparator';
import SelectEditor from '_legacy/modules/shared/columns/editors/SelectEditor';
import { isEditableRow } from '_legacy/modules/shared/columns/tools/headingTools';

export const getintraInterRegionalTypes = () => {
    return ['', 'Extra-Regional', 'Intra-Basin'];
};

const intraInterRegionalHeading = {
    colId: 'intraInterRegional',
    headerName: 'Intra/Inter Regional',
    field: 'intraInterRegional',
    width: 120,
    editable: isEditableRow,
    cellEditorFramework: SelectEditor,
    hide: true,
    cellEditorParams: {
        valuesByDataset: getintraInterRegionalTypes,
    },
    suppressKeyboardEvent: allowUpAndDownOnEdit(),
    cellClassRules: {
        ...commonRowAndCellClassRules,
    },
    filterParams: {
        ...defaultSetFilterParams,
        comparator: naturalSortComparator,
    },
};

export default intraInterRegionalHeading;
